import {
  CdkVirtualScrollViewport,
  FixedSizeVirtualScrollStrategy,
  VIRTUAL_SCROLL_STRATEGY,
} from '@angular/cdk/scrolling';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Injectable,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
  OnChanges,
} from '@angular/core';
import { AssetState } from '@analysis/domain';
import { IAssetItem } from '@analysis/domain';

@Injectable()
export class CustomVirtualScrollStrategy extends FixedSizeVirtualScrollStrategy {
  constructor() {
    super(90, 45, 45);
  }
}
@Component({
  selector: 'ts-sample-reference-strip',
  templateUrl: './sample-reference-strip.component.html',
  styleUrls: ['./sample-reference-strip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: VIRTUAL_SCROLL_STRATEGY, useClass: CustomVirtualScrollStrategy }],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SampleReferenceStripComponent implements OnChanges {
  @ViewChild(CdkVirtualScrollViewport) viewPort: CdkVirtualScrollViewport;
  @Input() public readonly items: IAssetItem[];
  @Input() public readonly viewedItems: string[];
  @Input() public readonly favAssets: string[];
  @Input() public readonly analyzedAssets: string[];
  @Input() public readonly reviewedAssets: string[];
  @Input() public readonly selectedIndex: number;
  @Input() public readonly bookmarkedAsset: string;

  @Output() public readonly changeIndex = new EventEmitter<number>();
  /** Emits the strip's visibility whenever the user collapses/expands it, so hosts can move
   *  companion overlays (e.g. a minimap) along with the strip. */
  @Output() public readonly visibilityChanged = new EventEmitter<boolean>();
  /** Emits when the user right-clicks a thumbnail, with the item and cursor position, so hosts can
   *  open a per-asset context menu (favourite / bookmark / download) at the pointer. */
  @Output() public readonly thumbnailContextMenu = new EventEmitter<{ item: IAssetItem; x: number; y: number }>();

  public State = AssetState;
  public isVisible = true;

  constructor(private cdr: ChangeDetectorRef) {}

  public toggleVisibility(): void {
    this.isVisible = !this.isVisible;
    this.visibilityChanged.emit(this.isVisible);
    this.cdr.markForCheck();
  }

  public onThumbnailContextMenu(event: MouseEvent, item: IAssetItem): void {
    event.preventDefault();
    this.thumbnailContextMenu.emit({ item, x: event.clientX, y: event.clientY });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedIndex?.currentValue !== undefined) {
      this.viewPort?.scrollToIndex(changes.selectedIndex.currentValue, 'smooth');
    }
  }
}
